import Indicator, { IndicatorType } from '../../types/Indicator'

const Echo: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'echo',
  label: 'Echo',
  fields: ['greenEcho', 'redEcho'],
  excludeSelfInRHS: true,
}

export default Echo
